module.exports = __webpack_public_path__ + "stylesheets/main_7fb4f69c714efbbba9f35f7211d58679.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/main.less
// module id = 3ksy
// module chunks = 153